import React from 'react';
import Resume from './pages'
import { Helmet } from 'react-helmet'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
        <Helmet>
            <meta charSet="utf-8" />
            <title>Esselight Portfolio Landing Page</title>
            <link rel="canonical" href="https://esselight.netlify.com/" />
        </Helmet>
      <Resume />
    </div>
  );
}

export default App;
